// Generated by npm run generate-i18n-catalogs. Do not edit directly.

export const catalogZhTW = {
  "controls": {
    "boot": "啟動",
    "reset": "重置",
    "copyScreen": "複製螢幕",
    "copyText": "複製文字",
    "pasteText": "貼上文字",
    "saveState": "儲存狀態",
    "restoreState": "還原狀態",
    "toggleSound": "切換音效",
    "settings": "設定",
    "debugPanel": "除錯面板",
    "infoPanel": "資訊面板",
    "reportIssue": "回報問題",
    "privacyPolicy": "隱私權政策"
  },
  "config": {
    "speed": "模擬器速度",
    "display": "顯示設定",
    "theme": "佈景主題",
    "openRetroControlPanel": "控制面板",
    "resetSettings": "重置所有設定",
    "capsLock": "大寫鎖定",
    "useOpenApple": "將 {{modKey}} 鍵用作 Open Apple 鍵",
    "useShortcuts": "將 {{modKey}} 鍵用於鍵盤快捷鍵",
    "useArrowKeys": "使用方向鍵作為搖桿",
    "scanlines": "CRT 掃描線",
    "ghosting": "螢幕殘影",
    "crtDistortion": "CRT 失真效果",
    "joystick": "搖桿設定"
  },
  "machine": {
    "configuration": "機器配置",
    "slotConfigurator": "擴充插槽"
  },
  "speed": {
    "snail": "蝸牛速度 (0.1 MHz)",
    "slow": "慢速 (0.5 MHz)",
    "normal": "正常速度 (1 MHz)",
    "fast": "快速 (4 MHz)",
    "warp": "極速"
  },
  "colors": {
    "color": "彩色",
    "nofringe": "彩色 (無邊緣)",
    "green": "綠色",
    "amber": "琥珀色",
    "white": "黑白",
    "inverse": "黑白 (反色)"
  },
  "themes": {
    "classic": "經典",
    "dark": "深色",
    "minimal": "簡約"
  },
  "debug": {
    "helpPanel": "顯示說明面板",
    "debugPanel": "顯示除錯面板",
    "expectinPanel": "顯示 Apple exPectin 面板",
    "helpTab": "說明",
    "debugTab": "除錯",
    "breakpoints": "中斷點",
    "memory": "記憶體",
    "stack": "堆疊",
    "state": "CPU 狀態",
    "registers": "暫存器",
    "flags": "旗標",
    "step": "單步執行",
    "stepOver": "跨越執行",
    "stepInto": "進入執行",
    "stepOut": "跳出執行",
    "resume": "恢復",
    "pause": "暫停",
    "loadSymbolTable": "載入符號表",
    "agentTab": "AI 代理",
    "disassembly": "反組譯"
  },
  "tour": {
    "welcome": "歡迎使用 Apple2TS 模擬器！",
    "clickNext": "若要瞭解更多，請按下一步按鈕。",
    "bootButton": "按這裡啟動模擬器。",
    "resetButton": "按這裡重置 Apple II，並重新開機或進入 BASIC。",
    "diskImages": "選擇其中一個已安裝的磁碟映像檔。",
    "floppyDisks": "或按一下軟碟圖示來載入磁碟映像檔。",
    "saveRestore": "您可以使用這些按鈕儲存和還原模擬器的完整狀態。",
    "themeButton": "按這裡變更模擬器 UI 佈景主題。",
    "endTour": "您已到達導覽的結尾。按一下地球儀導覽按鈕來試試其他導覽，或按完成開始使用模擬器。",
    "tourSelectorHint": "按一下地球儀導覽按鈕來試試其他導覽，或按完成開始使用模擬器。",
    "settingsWelcome": "Apple2TS 擁有一套完整的控制項，用於模擬器和 Apple II。若要瞭解更多，請按下一步按鈕。",
    "mainControls": "在這裡，您可以啟動和重置 Apple II，還原和儲存狀態，複製螢幕，或貼上文字到模擬器。",
    "snapshot": "在任何時候，您都可以擷取目前模擬器狀態的快照，然後回到早期狀態，或再次快進。您也可以將模擬器狀態與所有目前的快照一起儲存。",
    "pauseButton": "您可以隨時暫停模擬器，凍結 6502 處理器。這對於暫停遊戲中的動作或進入除錯器很有用。",
    "debugButton": "按一下除錯器圖示進入除錯模式，您可以查看 6502 處理器的內部狀態。再次按一下即可回到正常模式。",
    "configButtons": "底部一排按鈕控制 Apple II 的狀態，從模擬器速度、螢幕顏色和靜音開始。",
    "keyboardButtons": "如果開啟了大寫鎖定鍵，然後所有輸入的字元都是大寫的。",
    "altArrowKeys": "下一個按鈕決定 {{modKey}} 鍵是用於鍵盤快捷鍵還是 Apple II Open Apple 鍵。最後一個按鈕決定是否可以使用方向鍵作為 Apple II 的搖桿。",
    "clearCookies": "Apple2TS 會自動將目前的模擬器設定儲存為瀏覽器 cookie。按下此按鈕可重置這些設定並刪除 cookie。",
    "debugWelcome": "Apple2TS 擁有一套豐富的工具來分析和除錯 6502 組合語言代碼。若要瞭解更多，請按下一步按鈕。",
    "debugIcon": "按一下資訊頁籤上的除錯器圖示以查看除錯面板。",
    "debugPause": "按下暫停按鈕以暫停或恢復模擬器的執行。",
    "debugControls": "現在我們已經暫停了，我們可以使用「跳越執行」、「進入」和「跳出執行」按鈕逐步執行反組譯代碼。我們也可以快速跳轉到程式計數器 (PC) 的目前位址。",
    "debugDisassembly": "在這裡我們可以看到反組譯代碼，包括十六進位位址、三個字母的指令，以及任何數值或位址。如果您將滑鼠移動到綠色數值上，將會出現一個工具提示，顯示目前的數值。按一下藍色位址將捲動到該位置。您也可以按一下左側的欄位來新增或移除中斷點。",
    "debugInfo": "在中間我們有堆疊傾印和記憶體映射。記憶體映射會即時更新，並顯示目前使用中的記憶體組區。",
    "debugMemory": "最後一部分顯示 Apple II 的記憶體。您可以使用下拉清單來檢查記憶體的不同部分。如果您切換到其中一個 HGR 頁面，您將得到放大的高解析度螢幕視圖，與記憶體位置連接。您也可以搜尋十六進位數值或 ASCII 字串，並將記憶體儲存到檔案中。",
    "back": "上一步",
    "close": "關閉",
    "last": "完成",
    "next": "下一步",
    "nextLabelWithProgress": "下一步 (第 {step} 步，共 {steps} 步)",
    "skip": "關閉",
    "guidedTour": "引導式導覽",
    "mainLabel": "引導式導覽：主要",
    "settingsLabel": "引導式導覽：設定",
    "debugLabel": "引導式導覽：除錯"
  },
  "disk": {
    "drive1": "磁碟機 1",
    "drive2": "磁碟機 2",
    "hardDisk": "硬碟",
    "eject": "退出磁碟",
    "insert": "插入磁碟",
    "writeProtected": "防寫保護",
    "readWrite": "讀寫",
    "empty": "空的",
    "loading": "載入中...",
    "selectDisk": "選擇磁碟映像檔",
    "browse": "瀏覽",
    "newReleases": "新發行版",
    "writeProtectDisk": "磁碟防寫保護",
    "saveDiskToDevice": "儲存磁碟",
    "saveDiskTo": "儲存磁碟到",
    "saveDiskToMenu": "儲存磁碟到 >",
    "addToFavorites": "加入收藏",
    "downloadDisk": "下載磁碟",
    "downloadWoz": "下載 WOZ 磁碟映像",
    "downloadAndEjectDisk": "下載並退出磁碟",
    "ejectDisk": "退出磁碟",
    "ejectAllDisks": "退出全部磁碟",
    "saveDiskToOneDrive": "儲存磁碟到 OneDrive",
    "saveDiskToGoogleDrive": "儲存磁碟到 Google Drive",
    "loadDisk": "載入磁碟",
    "loadAdditionalDisks": "載入額外磁碟...",
    "loadDiskFrom": "從以下位置載入磁碟",
    "loadDiskFromMenu": "從以下位置載入磁碟 >",
    "loadDiskFromDevice": "載入磁碟",
    "loadDiskFromDeviceReadOnly": "從裝置載入磁碟 (唯讀)",
    "loadDiskFromDeviceReadWrite": "從裝置載入磁碟 (讀寫)",
    "loadDiskFromInternetArchive": "從 Internet Archive 載入磁碟",
    "loadDiskFromDemoZoo": "從 DemoZoo 載入磁碟",
    "loadDiskFromOneDrive": "從 OneDrive 載入磁碟",
    "loadDiskFromGoogleDrive": "從 Google Drive 載入磁碟",
    "insertBlankDisk": "插入空白磁碟",
    "syncEveryMinute": "每分鐘同步",
    "syncEvery5Minutes": "每 5 分鐘同步",
    "pauseSyncing": "暫停同步",
    "syncNow": "立即同步",
    "modified": "已修改",
    "synced": "已同步",
    "diskImage": "磁碟映像",
    "diskDrivesAndDevices": "磁碟機與設備",
    "syncedAt": "同步於 {{date}}",
    "clickToLoadDiskImage": "點擊載入磁碟映像",
    "clickToRemoveFromDiskCollection": "點擊從磁碟收藏移除",
    "clickToAddToDiskCollection": "點擊加入磁碟收藏",
    "byCreator": "作者：{{creator}}",
    "clickToViewDetails": "點擊查看詳情",
    "standbyDisks": "待命磁碟 (點擊更換磁碟)"
  },
  "help": {
    "title": "Apple2TS",
    "subtitle": "TypeScript Apple IIe 模擬器",
    "credit": "(c) {{year}} Chris Torrence 與 Apple2TS 貢獻者",
    "keyboardShortcuts": "鍵盤快捷鍵",
    "shortcutsUnavailable": "當 {{keyMod}} 鍵被指定為 Open Apple 時，使用該鍵的模擬器快捷鍵無法使用。Ctrl+0 到 Ctrl+5 仍可選擇模擬器速度。",
    "diskImages": "磁碟映像檔：",
    "diskContainers": "壓縮封裝檔：",
    "multiDiskNotice": "多磁碟置換：點擊磁碟圖示上的多碟標籤可開啟快速置換選單。載入多磁碟壓縮檔 (.zip, .7z, .gz) 會自動將所有磁碟載入置換清單。",
    "urlParameters": "選用的 URL 參數",
    "examples": "範例",
    "mobileInstructions": "行動平台：",
    "tapScreen": "點擊螢幕以顯示鍵盤。",
    "arrowKeys": "按方向鍵、ESC 或 Tab 按鈕將這些按鍵發送到模擬器。",
    "ctrlKey": "要發送控制字元，請按一次 Ctrl 按鈕。然後點擊螢幕顯示鍵盤並按所需的按鍵。Ctrl 按鈕將自動釋放。",
    "ctrlLock": "要發送多個控制字元，請按兩次 Ctrl 按鈕以鎖定（以綠點表示）。然後點擊螢幕顯示鍵盤並按所需的按鍵。再次按 Ctrl 按鈕以釋放。",
    "appleKeys": "Open Apple 和 Closed Apple 鍵的行為與 Ctrl 鍵相同。",
    "openAppleKey": "Open Apple: 按左側 Alt/Option",
    "closedAppleKey": "Closed Apple: 按右側 Alt/Option",
    "joystickKeys": "搖桿按鍵: 右側數字鍵 8/2/4/6 (7/9/1/3), 0/5, ./Enter",
    "onScreenKeyboard": "螢幕鍵盤：使用CTRL或ESC鍵時，\n點擊一次啟用，然後點擊所需的按鍵。",
    "urlParametersBody": "對於可選的URL參數，在URL後面加上問號(?)並附加參數，多個參數之間用(&)符號分隔。使用#指定磁碟映像。有關範例，請參閱連結建立器對話框。",
    "exampleLinks": {
      "totalReplayDebugging": "Total Replay (含除錯)",
      "totalReplayChoplifter": "Total Replay (載入 Choplifter，嵌入模式)",
      "a2Desktop": "A2Desktop 2MG (快速，彩色)",
      "embeddedBasic": "嵌入式 Applesoft BASIC 程式",
      "binaryHexAddress": "具有十六進位位址的二進位檔案"
    },
    "links": "連結",
    "resourceLinks": {
      "desktopApp": "Apple2TS 桌面應用程式",
      "corsProxy": "Corsfix 提供的 CORS 代理",
      "silverCjkFont": "Silver CJK Pixel Font"
    }
  },
  "messages": {
    "loading": "載入中...",
    "error": "錯誤",
    "success": "成功",
    "confirm": "確認",
    "cancel": "取消",
    "ok": "確定",
    "on": "開啟",
    "off": "關閉",
    "confirmTheme": "重新載入模擬器並立即套用此佈景主題嗎？",
    "confirmReset": "將所有設定重置為預設值嗎？",
    "fileNotFound": "找不到檔案",
    "invalidFile": "無效的檔案格式",
    "diskInserted": "已插入磁碟",
    "diskEjected": "已退出磁碟"
  },
  "keyboard": {
    "capsLock": "大寫鎖定",
    "space": "空白鍵",
    "backspace": "退格",
    "delete": "刪除"
  },
  "audio": {
    "speaker": "喇叭",
    "midi": "MIDI",
    "configuration": "音訊設定",
    "volume": "音量",
    "mute": "靜音",
    "waveform": "波形"
  },
  "print": {
    "printer": "印表機",
    "print": "列印",
    "clear": "清除",
    "save": "儲存輸出",
    "dumpScreen": "將目前螢幕傳送到印表機",
    "dumpScreenInverse": "將目前螢幕傳送（反色）",
    "sendToPrinter": "傳送到印表機",
    "tearOff": "撕下頁面並重設",
    "printedPage": "已列印頁面",
    "printerConfig": "印表機設定",
    "pageLength": "頁面長度",
    "pageLengthLetter": "11英吋（信紙）",
    "pageLengthA4": "11.7英吋（A4）",
    "pageLengthTwelve": "12英吋"
  },
  "device": {
    "machineConfiguration": "機器配置",
    "midiDeviceSelect": "MIDI 設備選擇",
    "serialPortSelect": "序列埠選擇",
    "mockingboardWaveform": "Mockingboard 波形"
  },
  "collection": {
    "showApple2TSCollection": "顯示 Apple2TS 收藏",
    "showNewReleases": "顯示新發行版",
    "showFavorites": "顯示最愛",
    "chooseDiskImage": "選擇磁碟映像",
    "diskCollection": "磁碟收藏",
    "clickToShowDetails": "點擊顯示詳情",
    "clickToLoadDisk": "點擊載入磁碟",
    "diskIsNewRelease": "磁碟是新發行版",
    "diskIsApple2TSCollection": "磁碟是 Apple2TS 收藏的一部分",
    "diskIsInternetArchive": "磁碟是 Internet Archive 的一部分",
    "clickToRemoveFromCollection": "點擊從磁碟收藏中移除",
    "clickToKeepInCollection": "點擊以保留在磁碟收藏中",
    "clickToAddToCollection": "點擊加入磁碟收藏",
    "diskIsSyncedVia": "磁碟透過同步",
    "loadDiskIntoDrive": "載入磁碟到磁碟機",
    "cloudAuthRequired": "需要驗證",
    "signIn": "登入",
    "exportDisksToHdv": "將磁碟匯出為HDV",
    "export": "匯出",
    "clickToRemoveFromSelected": "點擊從已選磁碟中移除",
    "clickToAddToSelected": "點擊新增至已選磁碟",
    "reportExportIssue": "回報匯出問題"
  },
  "debugControls": {
    "goBackInTime": "回到過去",
    "takeSnapshot": "擷取快照",
    "goForwardInTime": "向前跳躍",
    "saveStateWithSnapshots": "保存狀態及快照",
    "resume": "繼續",
    "pause": "暫停",
    "trace": "追蹤",
    "tracing": "正在追蹤",
    "downloadTraceLog": "下載追蹤紀錄"
  },
  "fullscreen": {
    "fullScreen": "全螢幕"
  },
  "internetArchive": {
    "searchPlaceholder": "輸入軟體名稱或點擊上方分類",
    "go": "搜尋"
  },
  "demoZoo": {
    "searchPlaceholder": "搜尋 DemoZoo 作品或作者...",
    "go": "搜尋"
  },
  "basic": {
    "newProgram": "新程式",
    "runFromBeginning": "從頭開始執行",
    "break": "中斷",
    "continueRunning": "繼續執行",
    "stepProgram": "單步執行程式",
    "resumeOutput": "恢復輸出",
    "freezeOutput": "凍結輸出",
    "importProgram": "匯入程式...",
    "exportProgram": "匯出程式...",
    "renumberProgram": "重新編號程式",
    "rebuildProgram": "從記憶體重建程式",
    "displaySettings": "顯示設定",
    "autoLineNumbering": "自動行號",
    "capitalizeKeywords": "關鍵字大寫",
    "rebuildWarning": "此操作將會用從 Apple II 記憶體中重建的版本取代目前的程式。您將會遺失所有未儲存的變更。是否確定要繼續？",
    "variable": "變數",
    "value": "值"
  },
  "expectin": {
    "runScript": "執行腳本",
    "stopScript": "停止腳本"
  },
  "saveDisassembly": {
    "title": "儲存反組譯",
    "startAddress": "開始位址 $",
    "endAddress": "結束位址 $",
    "includeLabels": "包含符號標籤",
    "separatorLines": "在 JMP、RTS 後加入分隔線"
  },
  "gamepad": {
    "useArrowKeys": "使用方向鍵作為搖桿",
    "siriusJoyport": "Sirius 搖桿埠模式",
    "reverseYAxis": "反轉搖桿 Y 軸"
  },
  "traceSettings": {
    "title": "追蹤設定",
    "numLines": "保留的行數：",
    "rangeWarning": "必須介於 100 到 100000 之間",
    "collapseLoops": "尋找重複行並摺疊迴圈",
    "ignoreRegisters": "尋找重複行時忽略暫存器數值",
    "settings": "設定"
  },
  "keyboardControl": {
    "hideKeyboard": "隱藏鍵盤",
    "showKeyboard": "顯示鍵盤"
  },
  "linkBuilder": {
    "title": "連結產生器",
    "buttonTitle": "連結產生器",
    "userInterface": "使用者介面：",
    "machine": "主機型號：",
    "colorMode": "顏色模式：",
    "ramDiskSize": "RAM 磁碟大小 (KB)：",
    "emulatorSpeed": "模擬器速度：",
    "uiTheme": "介面主題：",
    "showDebugTab": "顯示除錯分頁",
    "sound": "音效",
    "startupOptionsTab": "啟動選項",
    "onStartup": "啟動時：",
    "loadDiskImage": "載入磁碟映像檔",
    "loadBasicProgram": "載入 BASIC 程式",
    "loadHexCode": "載入 16 進位碼",
    "diskImageToLoad": "啟動時載入的磁碟映像檔：",
    "customDiskUrl": "自定義磁碟映像網址：",
    "textToType": "載入磁碟後輸入的文字：",
    "enterTextPlaceholder": "在此輸入文字或 BASIC 程式碼",
    "runBasicAfterLoading": "載入後執行 BASIC 程式",
    "enterHexPlaceholder": "在此輸入 16 進位碼，例如：A9 01 8D 00 03",
    "hexLoadAddress": "16 進位載入位址：$",
    "runHexAfterLoading": "載入後執行 16 進位程式",
    "finalUrl": "最終網址：",
    "copyToClipboard": "複製到剪貼簿",
    "tryIt": "嘗試執行",
    "reset": "重設",
    "close": "關閉",
    "customDiskUrlOption": "自定義網址",
    "gameModes": {
      "normal": "正常",
      "game": "遊戲 (無磁碟機與分頁)",
      "embed": "嵌入 (隱藏所有控制項)"
    },
    "colorNames": {
      "color": "彩色",
      "nofringe": "彩色 (無邊緣)",
      "green": "綠色螢幕",
      "amber": "琥珀色螢幕",
      "white": "白色螢幕",
      "inverse": "反白螢幕"
    },
    "speedNames": {
      "snail": "極慢",
      "slow": "慢速",
      "normal": "1 MHz (預設)",
      "warp": "極速"
    },
    "machines": {
      "enhanced": "Apple IIe (增強型)",
      "unenhanced": "Apple IIe (非增強型)"
    },
    "themes": {
      "classic": "經典",
      "dark": "深色",
      "minimal": "簡約"
    },
    "ramDiskSizes": {
      "512": "512",
      "1024": "1024",
      "4096": "4096",
      "8192": "8192",
      "default": "64 (預設)"
    },
    "slots": {
      "configure": "設定插槽擴充卡",
      "slot": "插槽 {{slot}}:",
      "cardNone": "無 (空)"
    },
    "additionalDiskDrives": "額外磁碟機",
    "slot6Drive1": "插槽 6 磁碟機 1 (軟碟 1)",
    "slot6Drive2": "插槽 6 磁碟機 2 (軟碟 2)",
    "slot7Drive1": "插槽 7 磁碟機 1 (硬碟 1)",
    "slot7Drive2": "插槽 7 磁碟機 2 (硬碟 2)",
    "slot2Drive1": "插槽 2 磁碟機 1 (VERA SD)",
    "slot4Drive1": "插槽 4 磁碟機 1 (VERA SD)",
    "addAdditionalDisk": "新增用於更換的額外磁碟",
    "removeDisk": "移除此磁碟",
    "addAnotherDisk": "新增其他磁碟",
    "diskPlaceholder": "磁碟 {num} 檔名 (例如 sideB.woz|劇情磁碟)"
  },
  "agent": {
    "tabTitle": "AI 代理",
    "setupTitle": "🤖 AI 代理設定",
    "setupInstruction": "點擊下方的齒輪圖示以設定您的 AI 助理。",
    "welcomeTitle": "歡迎使用 Apple II 助理！我可以協助您：",
    "welcomeItem1": "檢查 CPU 暫存器與記憶體",
    "welcomeItem2": "控制執行狀態（啟動、重置、單步執行、中斷點）",
    "welcomeItem3": "載入程式與管理磁碟",
    "welcomeItem4": "除錯 6502 組合語言程式碼",
    "welcomeItem5": "讀取螢幕內容與系統狀態",
    "welcomePrompt": "歡迎隨時向我提問！",
    "userRole": "您",
    "assistantRole": "🤖 助理",
    "inputPlaceholder": "向我詢問關於 Apple II 模擬器的任何問題... (按 Enter 送出，Shift+Enter 換行)",
    "stop": "停止",
    "send": "傳送",
    "changeConfiguration": "變更設定",
    "processing": "處理中...",
    "tokens": "• 輸入 {{input}} / 輸出 {{output}}",
    "configTitle": "設定 AI 代理",
    "provider": "提供商：",
    "model": "模型：",
    "apiKey": "API 金鑰：",
    "ollamaUrl": "Ollama 網址：",
    "save": "儲存",
    "clear": "清除",
    "storageWarning": "您的 API 金鑰會儲存在本機瀏覽器中，絕不會傳送至 apple2ts.com。取得您的 {{provider}} API 金鑰：",
    "ollamaWarning": "Ollama 會在您的本機電腦上執行。請確保您已安裝並啟動 Ollama。下載網址：",
    "providerNotConfigured": "尚未設定提供商 - 請點擊齒輪圖示以設定您的 AI 代理",
    "providerConfigured": "提供商：{{provider}} ({{model}})",
    "invalidKeyFormat": "{{provider}} 的 API 金鑰格式不正確"
  },
  "startup": {
    "welcome": "歡迎使用 Apple2TS",
    "subtitle": "TypeScript Apple II 模擬器",
    "copyright": "(c) {{year}} C.Torrence + 協作者",
    "diskCollections": "點擊磁碟集合圖示\n載入內建磁碟或遊戲。"
  },
  "retroControl": {
    "machine": "機器",
    "fullscreen": "全螢幕",
    "diskCollection": "磁碟",
    "diskDrives": "磁碟機",
    "display": "顯示",
    "monitorMode": "顯示器模式",
    "monitorModeChoice": {
      "ntsc": "NTSC",
      "rgb": "RGB"
    },
    "sound": "聲音",
    "options": "選項",
    "skin": "外觀",
    "personalization": "個人化",
    "text": "文字",
    "background": "背景",
    "border": "邊框",
    "iigsColor": {
      "black": "黑色",
      "red": "紅色",
      "darkBlue": "深藍色",
      "purple": "紫色",
      "darkGreen": "深綠色",
      "darkGray": "深灰色",
      "mediumBlue": "中藍色",
      "lightBlue": "淺藍色",
      "brown": "棕色",
      "orange": "橙色",
      "lightGray": "淺灰色",
      "pink": "粉紅色",
      "lightGreen": "淺綠色",
      "yellow": "黃色",
      "aquamarine": "海藍色",
      "white": "白色"
    },
    "keyboard": "鍵盤",
    "joystick": "搖桿",
    "slots": "插槽",
    "devices": "裝置",
    "printerPort": "印表機連接埠",
    "modemPort": "數據機連接埠",
    "quit": "結束",
    "apple2tsCollection": "Apple2TS 收藏",
    "newReleases": "最新發行",
    "favorites": "我的最愛",
    "exportDisksToHdv": "將磁碟匯出為 HDV",
    "noDiskDrivesAvailable": "沒有可用的磁碟機",
    "select": "選取",
    "open": "開啟",
    "load": "載入",
    "go": "前往",
    "save": "儲存",
    "clipboard": "剪貼簿",
    "cancelEsc": "取消:Esc",
    "color": "色彩",
    "systemSpeed": "系統速度",
    "other": "其他",
    "timeMachine": "快照",
    "ports": "連接埠",
    "language": "語言",
    "retroTheme": "復古",
    "lowercaseInput": "小寫輸入",
    "openAppleKey": "開放蘋果鍵",
    "sortOrder": "排序",
    "card": {
      "empty": "空白",
      "mockingboard": "Mockingboard"
    }
  }
}
